


























































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import companyTree from './companyTree.vue'
import RulesApi from '@/api/rules'
import listMixins from '@/mixins/list'
import { debounce } from '@/utils/util'
const debounce300 = debounce(300)
const columns = [
	{
		title: '序号',
		key: 'index',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'index' },
	},
	{
		title: '名称',
		dataIndex: 'ruleName',
		align: 'center',
	},
	{
		title: '描述',
		dataIndex: 'ruleDesc',
		align: 'center',
	},
	{
		title: '状态',
		dataIndex: 'status',
		align: 'center',
		scopedSlots: { customRender: 'status' },
	},
	{
		title: '操作',
		key: 'action',
		align: 'center',
		scopedSlots: { customRender: 'action' },
	},
]

@Component({
	name: 'WPRulesList',
	components: {
		PageLayout,
		companyTree,
	},
})
export default class RulesList extends Mixins(listMixins) {
	private company = {
		id: '',
		title: '',
	}
	private rulesList: any[] = []
	private columns = columns

	@Watch('company', { immediate: true })
	private onCompanyChange() {
		this.getList()
	}

	private toggleStatus(row: any) {
		const toEnable = row.status === '0'
		this.$confirm({
			title: '提示',
			content: `请确定是否${toEnable ? '启用' : '停用'}该规则`,
			onOk: () => {
				return RulesApi.toggleStatus({
					ruleId: row.id,
					enable: toEnable ? '1' : '0',
				}).then(() => {
					this.getList()
				})
			},
			onCancel() {},
		})
	}

	private go2AddRule() {
		if (this.company.id) {
			this.$multiTab.close('/Settings/Rules/addRule')
			this.$ls.set('addRuleCompanyId', this.company.id)
			this.$nextTick(() => {
				this.$multiTab.open('/Settings/Rules/addRule')
			})
		} else {
			this.$message.error('请先选择公司')
		}
	}

	private go2EditRule(id: string) {
		if (this.company.id) {
			this.$multiTab.close('/Settings/Rules/editRule')
			this.$ls.set('editRuleCompanyId', this.company.id)
			this.$ls.set('settingRuleId', id)
			this.$nextTick(() => {
				this.$multiTab.open('/Settings/Rules/editRule')
			})
		} else {
			this.$message.error('请先选择公司')
		}
	}

	private removeRule(id: string) {
		this.$confirm({
			title: '提示',
			content: '请确定是否删除该规则',
			onOk: () => {
				return RulesApi.removeRule(id).then(() => {
					this.getList()
				})
			},
			onCancel() {},
		})
	}

	private initTreeCb() {
		// 默认取总公司规则配置
		const companyTree = this.$store.state.setting.companyTree
		if (!(this.company && this.company.id)) {
			this.company = {
				id: companyTree[0].key,
				title: companyTree[0].title,
			}
		}
	}

	public getList() {
		if (this.company && this.company.id) {
			const form: any = {
				pageSize: this.pageSize,
				pageNum: this.current,
			}
			if (String(this.company.id).trim()) {
				form.companyId = this.company.id
			}
			return RulesApi.getRuleList(form).then((res: any) => {
				this.rulesList = res.data && res.data.retList
				this.total = res.data && res.data.count
			})
		} else {
			return Promise.resolve()
		}
	}

	private onSelectCompany(company: any) {
		this.company = company
	}

	private setHeight() {
		debounce300(() => {
			// 依赖App.vue中设置content的marginTop
			const contentEl: any = document.querySelector('.content')
			if (!contentEl) {
				return
			}

			const contentRect: any = contentEl.getBoundingClientRect()
			const contentStyle: any =
				window.getComputedStyle(contentEl) || contentEl.currentStyle
			const rulesWrapper: any = this.$refs.rulesWrapper
			if (rulesWrapper) {
				const contentBottom: number = parseFloat(
					contentStyle && contentStyle.marginBottom
				)
				rulesWrapper.style.height =
					document.body.clientHeight - contentRect.y - contentBottom + 'px'
			}
		})
	}

	public activated() {
		this.getList()
	}

	private mounted() {
		window.addEventListener('resize', this.setHeight)
	}

	private beforeDestroy() {
		window.removeEventListener('resize', this.setHeight)
	}
}
